module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one__modal"
  }, [(_vm.noChartData) ? _c('p', [_vm._v("\n        There are no matching claims to show a comparison.\n    ")]) : _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('div', {
    staticClass: "p-day-one__chart-select-box-label"
  }, [_vm._v("Compare Against:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartType),
      expression: "chartType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.chartTypes), function(text, type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                            " + _vm._s(text) + "\n                        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('div', {
    staticClass: "p-day-one__chart-select-box-label u-r-margin-top-20"
  }, [_vm._v("Filter:")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterAttr),
      expression: "filterAttr"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterAttr = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filterTypes), function(text, type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                                " + _vm._s(text) + "\n                            ")])
  }), 0)])])]), _vm._v(" "), _c('bell-chart', {
    attrs: {
      "chart-data": _vm.forChart,
      "user-percentile": _vm.userPercentile,
      "user-label": _vm.ordinalSuffixOf(_vm.userPercentile)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("This Assessment")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Value of your assessment (" + _vm._s(_vm.filterTypes[_vm.filterAttr]) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.userValue, "£", 0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Percentile for this claim:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ordinalSuffixOf(_vm.userPercentile)))])])]), _vm._v(" "), _c('h2', {
    staticClass: "u-margin-top-30"
  }, [_vm._v("Values of Matched Claims")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Full Range of Matched Claims")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.scaleMin, "£", 0)) + " - " + _vm._s(_vm.currencyFormat(_vm.scaleMax, "£", 0)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0-25th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.minPercentileLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25th - 75th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.midPercentileLabel))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("75th - 100th Percentile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.maxPercentileLabel))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f4d7cd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/ReservePerformanceChart.vue
// module id = 1782
// module chunks = 0